<div class="flex align-items-center">
  <img src="assets/images/logo-icon.svg" alt="logo-icon" class="md:hidden" />
  <p-divider layout="vertical" class="md:hidden" />

  @if (subtitle(); as subtitle) {
    <h3 [innerHTML]="subtitle" class="hidden md:inline-block text-primary m-0 font-normal"></h3>
    <p-divider layout="vertical" class="hidden md:inline-block" />
  }

  <div class="flex align-items-center gap-2 bg-primary border-round-sm px-3 py-2 title-wrapper">
    @if (companyRoutesIconsMap[routePath]; as companyRouteIcon) {
      <span class="dps-icon dps-icon-{{ companyRouteIcon }}"></span>
    }
    <h3 class="m-0 font-normal text-center" [innerHTML]="title()"></h3>
  </div>
</div>

<div class="flex align-items-center flex-grow-1 px-2">
  <ng-content />
</div>

<dps-app-locale-selector class="hidden sm:inline-block align-self-center" />
